import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'

@Component({
  imports: [FormsModule],
  selector: 'div[app-text-input]',
  host: {
    '[class.slim]': 'slim',
  },
  styles: `
        :host {
            width: 100%;
            border: none;
            border-bottom: 1px solid black;
            padding-top: 1rem;

            input {
                width: 100%;
                border: none;  
                height: 100%; 
                &:focus {
                  outline: none;
                }
            }

            &.slim {
                border: none;
                padding: 0;
            }
        }
    `,
  template: `
        <input type="text" [class.slim]="slim" [ngModel]="value" [placeholder]="placeholder" [disabled]="disabled" (keyup)="handleKeyup($event)" (blur)="handleBlur($event)"/>
    `,
})
export class TextInputComponent {
  @Input() value: string | null | undefined = ''
  @Input() placeholder = ''
  @Input() disabled = false
  @Input() slim = false
  @Output() valueChange = new EventEmitter<string>
  @Output() blur = new EventEmitter<string>

  handleKeyup(evt: KeyboardEvent) {
    evt.stopImmediatePropagation()
    evt.preventDefault()
    const value = (evt.target as HTMLInputElement)?.value as string ?? ''
    this.valueChange.emit(value ?? '')
  }

  handleBlur(evt: FocusEvent) {
    evt.stopImmediatePropagation()
    evt.preventDefault()
    const value = (evt.target as HTMLInputElement)?.value as string ?? ''
    this.blur.emit(value ?? '')
  }

}